const LONG_QUERY_CACHING_CONFIG = {
  staleTime: Infinity,
  cacheTime: 24 * 60 * 60 * 1000, // 24 hours
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export default LONG_QUERY_CACHING_CONFIG;
